// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Summary`
};

const el_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Παραγγελία`
};

const ru_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Итого`
};

const he_summary = /** @type {(inputs: {}) => string} */ () => {
	return `סיכום`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const summary = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.summary(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("summary", locale)
	if (locale === "en") return en_summary(inputs)
	if (locale === "el") return el_summary(inputs)
	if (locale === "ru") return ru_summary(inputs)
	if (locale === "he") return he_summary(inputs)
	return "summary"
};